import { Checkbox, CheckboxProps } from '@mui/material';
import { checkboxIconProps } from 'Components/CheckboxIcons';

export const SimpleCheckbox = (props: CheckboxProps) => {
  const { icon, checkedIcon } = checkboxIconProps();
  return <Checkbox icon={icon} checkedIcon={checkedIcon} {...props} />;
};
